
<!-- https://coderwall.com/p/uer3ow/total-input-type-file-style-control-with-pure-css -->
<template>
    <div class='inline-auto-width hand-cursor'>
        <label class='fileContainer hand-cursor'>
        <b-button class='hand-cursor' variant='outline-secondary' size='sm'>{{ prompt }} <span class="glyphicon glyphicon-open"></span></b-button>
            <input class='hand-cursor' v-if='isImage' type='file' @change='onFileChange' accept='.png,.jpg,.jpeg,image/png,image/jpeg'>
            <input class='hand-cursor' v-if='!isImage' type='file' @change='onFileChange' accept=".wif">
        </label>
    </div>
</template>

<script>

export default {
    props: {
        isImage: {  // true means read base 64 image for local display, false means read wif text
            type: Boolean,
            required: true
        },
        prompt: {
            type: String,
            required: true
        }
    },
    mixins: [],
    data: function() {
        return {
            form: {
                email: '',
                message: ''
            },
            formSubmitAttempted: false,
            messageSent: false
        }
    },
    methods: {
        onFileChange(e) {
            let files = e.target.files || e.dataTransfer.files
            if (!files.length) {
                return
            }
            this.readFileContents(files[0])
        },
        readFileContents(file) {
            var reader = new FileReader()
            var vm = this

            reader.onload = (e) => { // called when file is successfully read into memory
                let fileContents = e.target.result
                vm.$emit('fileReceived', { fileContents: fileContents, fileName: file.name })
            }
            if (this.isImage) {
                reader.readAsDataURL(file)
            }
            else {
                reader.readAsText(file)
            }
        },
        created() {
        }
    }
}
</script>

<style scoped>
.fileContainer {
    overflow: hidden;
    position: relative;
    cursor: pointer;
}

.fileContainer [type=file] {
    cursor: pointer;
    display: block;
    font-size: 999px;
    filter: alpha(opacity=0);
    min-height: 100%;
    min-width: 100%;
    opacity: 0;
    position: absolute;
    right: 0;
    text-align: right;
    top: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/FileUpload.vue